/**
 * CTA underline — draw on scroll into view
 *
 * Adds .is-drawn to each .cta-link the first time it enters the viewport, which
 * wipes its brush underline in from left to right. Links are shown drawn when
 * IntersectionObserver is unavailable or reduced motion is preferred.
 *
 * [data-draw-in] gets the same treatment, for any other artwork that should
 * play its draw once on entering the viewport — the CSS decides the direction
 * and any delay.
 *
 * Larger artwork that should track the scrollbar rather than play once uses
 * data-draw instead — see assets/js/src/draw-on-scroll.js.
 */
( function () {
	'use strict';

	function init() {
		var links = document.querySelectorAll( '.cta-link, [data-draw-in]' );

		if ( ! links.length ) {
			return;
		}

		var reduced = window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

		if ( reduced || ! ( 'IntersectionObserver' in window ) ) {
			for ( var i = 0; i < links.length; i++ ) {
				links[ i ].classList.add( 'is-drawn' );
			}
			return;
		}

		var observer = new IntersectionObserver( function ( entries ) {
			for ( var i = 0; i < entries.length; i++ ) {
				if ( entries[ i ].isIntersecting ) {
					entries[ i ].target.classList.add( 'is-drawn' );
					observer.unobserve( entries[ i ].target );
				}
			}
		}, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 } );

		for ( var j = 0; j < links.length; j++ ) {
			observer.observe( links[ j ] );
		}
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
